export default function ListSort(List) {
  return List.sort((a, b) => {
    var x = a["content"];
    var y = b["content"];
    return x < y ? -1 : x > y ? 1 : 0;
  });
}
